import { Grid, makeStyles, Theme } from "@material-ui/core";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { useDocumentStore } from "@roc/feature-documents";
import { PayoffFieldsCard } from "./subComponents/payoffFieldsCard";
import { PayoffCalculatorCard } from "./subComponents/payoffCalculatorCard";
import { PayoffServicerFeesCard } from "./subComponents/payoffServicerFeesCard";
import { PayoffProtectiveAdvancesCard } from "./subComponents/payoffProtectiveAdvancesCard";
import { PayoffFinalCard } from "./subComponents/payoffFinalCard";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
  }
}));

export const PayoffCalculator = observer(({ }) => {
  const classes = useStyles();

  const {
    documentStore: {
      documentFormStore: { payoffCalculatorStore },
    },
  } = useDocumentStore();

  useEffect(() => {
    payoffCalculatorStore.initialize();
  }, []);

  return (
    <Grid container spacing={1} className={classes.container}>
      <Grid item xs={12}>
        <PayoffFieldsCard />
      </Grid>
      <Grid item xs={12}>
        <PayoffCalculatorCard />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={1} justifyContent="flex-end">
          <Grid item xs={12}>
            <PayoffServicerFeesCard />
          </Grid>
          <Grid item xs={12}>
            <PayoffProtectiveAdvancesCard />
          </Grid>
          <Grid item xs={6}>
            <PayoffFinalCard />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
});